export const CALL_OUTBOUND_PREAUTH_REQUEST = 'CALL_OUTBOUND_PREAUTH_REQUEST';
export const CALL_OUTBOUND_PREAUTH_SUCCESS = 'CALL_OUTBOUND_PREAUTH_SUCCESS';
export const CALL_OUTBOUND_PREAUTH_FAILURE = 'CALL_OUTBOUND_PREAUTH_FAILURE';
